import { AuthStatus } from '@power-point/enums'
import { IMSAuthErrorResult, IMSAuthResult } from '@interfaces/app.interfaces'
import msalInstance from '@utils/auth-config'
import { getValidEmail } from '@utils/index'
import './login.css'
;(() => {
  // The initialize function must be run each time a new page is loaded
  Office.initialize = () => {
    void msalInstance.initialize().then(async () =>
      // handleRedirectPromise should be invoked on every page load
      msalInstance
        .handleRedirectPromise()
        .then(async response => {
          // If the response is non-null, it means the page is returning from AAD with a successful response
          if (response) {
            const claims = response.idTokenClaims as Record<string, string> | undefined
            const account = response.account

            const result: IMSAuthResult = {
              firstName: claims?.given_name || account?.name?.split(' ')[0],
              lastName: claims?.family_name || account?.name?.split(' ').slice(1).join(' '),
              email: getValidEmail(claims?.email, account?.username),
              mstoken: response.idToken
            }
            Office.context.ui.messageParent(JSON.stringify({ status: AuthStatus.success, result }))
          }
          // Otherwise, invoke login
          else
            await msalInstance.loginRedirect({
              scopes: ['openid', 'profile', 'email', 'user.read']
            })
        })
        .catch(error => {
          console.error('Auth error: ', error)
          const errorResult: IMSAuthErrorResult = {
            errorCode: error.errorCode,
            errorMessage: error.errorMessage
          }
          Office.context.ui.messageParent(JSON.stringify({ status: AuthStatus.failure, result: errorResult }))
        })
    )
  }
})()
